import axios from 'axios'

const state = () => ({
  newsImages: []
})

const getters = {
 newsImages(state) {
    return state.newsImages
  }
}

const mutations = {
  SET_NEWSIMAGES(state, payload){
    state.newsImages = payload
  },
  DELETE_IMAGES(state, id){
    state.newsImages = state.newsImages.filter((x) => x.id != id);
  },
  ADD_IMAGES(state, data){
    state.newsImages.push(data);
  },
  EDIT_NEW_IMAGES(state, data){
    state.newsImages = state.newsImages.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    })
  }
}

const actions = {
  getNewsImages({commit}){
    axios.get('https://api.geomalaka.uz/api/main/news_image/')
    .then((res)=>{
      commit("SET_NEWSIMAGES", res.data)
      // this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  getNewsImagesById({commit}, id){
    axios.get(`https://api.geomalaka.uz/api/main/news_image/${id}/`)
    .then((res)=>{
      commit("SET_NEWSIMAGES", res.data)
      this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  deleteImage({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/news_image/${id}/`)
    .then((res)=>{
      commit("DELETE_IMAGES", id)
      this._vm.$toast('Deleted', {type: 'success'})
      location.reload()
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  addImages({commit}, payload){
    axios.post(`https://api.geomalaka.uz/api/main/news_image/`, payload)
    .then((res)=>{
      commit("ADD_IMAGES", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
      location.reload()
    })
    .catch((error)=>{
      this._vm.$toast(error.message, {type: 'error'});
    })
  },
  editNewsImages({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/news_image/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_NEW_IMAGES", res.data)
        this._vm.$toast('Successful', {type: 'success'})
        location.reload()
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }

}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

